angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "ACTIVITIES": {
    "TRANSLATION": "Translation & Interpretation",
    "DRIVING": "Pick up & Driving Tours",
    "SHOPPING": "Shopping",
    "NIGHTLIFE": "Nightlife & Bars",
    "FOOD": "Food & Restaurants",
    "MUSEUMS": "Art & Museums",
    "RECREATION": "Sports & Recreation",
    "CULTURE": "History & Culture",
    "SIGHTSEEING": "Exploration & Sightseeing"
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/constants/activities.json
// module id = 113
// module chunks = 24